import { jsx as _jsx } from "react/jsx-runtime";
const Button = ({ children, onClick, className }) => {
    return (_jsx("button", { className: `sudoku-controls__button ${className}`, onClick: onClick, children: children }));
};
export default Button;
